import { SEPAPaymentRailTypeEnum } from '@finxone-platform/form-action';
import { AccountInfoType, SavingsAccountInfoType } from '@finxone-platform/shared/sys-config-types';
import { Observable } from 'rxjs';

/** Current account emission, including the active multi-currency code selection. */
export type CurrentAccountInfo = (AccountInfoType & { currentMultiCurrencyCode?: string }) | undefined;

/**
 * DI seam exposing the account/form state reads that the currency-amount-input widget needs.
 * The web frontend provides the concrete implementation backed by its NGXS states.
 */
export abstract class CurrencyAmountStateAccessor {
  abstract getCurrentAccount(): Observable<CurrentAccountInfo>;
  abstract getCurrentSavingsAccount(): Observable<SavingsAccountInfoType | undefined>;
  abstract getSepaPaymentRail(): SEPAPaymentRailTypeEnum | undefined;
}
